import React from 'react';
const bonuses = [{
  num: '01',
  emoji: '🔥',
  title: 'Einfaches Scouting-Kit',
  desc: 'Module zur Analyse des Gegners und deines eigenen Teams ohne teure Software.'
}, {
  num: '02',
  emoji: '📅',
  title: 'Der Strategie-Planer (Agenda)',
  desc: 'Der ultimative Planer für Spiele, Nominierungen und Monatsziele.'
}, {
  num: '03',
  emoji: '📋',
  title: 'Internes Mannschafts-Reglement',
  desc: 'Fertiges Dokument zur Disziplin-Verwaltung für Spieler und Eltern.'
}, {
  num: '04',
  emoji: '🔍',
  title: 'Leitfaden für Leistungstests',
  desc: 'Einfache Protokolle zur Messung von Sprungkraft, Schnelligkeit und Kraft.'
}, {
  num: '05',
  emoji: '🏆',
  title: 'Urkunden & MVP-Zertifikate',
  desc: 'Ehrenurkunden zur Belohnung von Einsatz und Talent deiner Spieler.'
}, {
  num: '06',
  emoji: '📝',
  title: 'Präventions-Protokoll',
  desc: 'Aufwärm- und Mobilitätsübungen zum Schutz von Schultern und Knien.'
}];
export function BonusSection() {
  return <section className="w-full bg-bg-main py-20 px-4" data-id="element-10">
      <div className="max-w-4xl mx-auto" data-id="element-11">
        <div className="text-center mb-14" data-id="element-12">
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-3 tracking-tight" data-id="element-13">
            6 Exklusive Boni inklusive
          </h2>
          <p className="text-text-sec text-lg sm:text-xl font-medium mb-2" data-id="element-14">
            (Ohne Zusatzkosten)
          </p>
          <p className="text-badge-red font-black text-xl sm:text-2xl line-through opacity-90" data-id="element-15">
            Gesamtwert der Boni: 67 €
          </p>
        </div>

        <div className="space-y-4" data-id="element-16">
          {bonuses.map((bonus, i) => <div key={i} className="bg-bg-alt rounded-2xl border border-border-light p-5 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-5 transition-transform hover:-translate-y-1 hover:border-secondary/30 group" data-id="element-17">
              {/* Emoji + Number Badge */}
              <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-secondary/20 to-secondary/5 border border-secondary/20 flex items-center justify-center flex-shrink-0 text-2xl shadow-inner group-hover:from-secondary/30 transition-colors" data-id="element-18">
                {bonus.emoji}
              </div>

              {/* Info */}
              <div className="flex-1 min-w-0" data-id="element-19">
                <h4 className="text-text-main font-bold text-lg sm:text-xl mb-0.5" data-id="element-20">
                  {bonus.title}
                </h4>
                <p className="text-text-sec text-sm sm:text-base leading-relaxed" data-id="element-21">
                  {bonus.desc}
                </p>
              </div>

              {/* GRATIS badge */}
              <span className="bg-secondary/10 text-secondary border border-secondary/20 px-3 py-1.5 rounded-lg font-black text-sm sm:text-base flex-shrink-0 shadow-[0_0_10px_rgba(245,158,11,0.2)]" data-id="element-22">
                GRATIS
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}